export const investorRelationsToTableParser = (data = []) => {
  return data?.map((el) => [[el]]);
};
